import React, { useState, useEffect } from 'react';
import axios from 'axios';

function Home() {
    const [username, setUsername] = useState('');
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [query, setQuery] = useState('');
    const [results, setResults] = useState([]);
    const [searched, setSearched] = useState(false);
	const [contactStatus, setContactStatus] = useState('');

const handleContact = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    try {
        const res = await fetch('https://formsubmit.co/ajax/support@sime.gr', {
            method: 'POST',
            body: formData
        });
        const data = await res.json();
        if (data.success) {
            setContactStatus('success');
            e.target.reset();
            setTimeout(() => setContactStatus(''), 3000);
        }
    } catch {
        setContactStatus('error');
    }
};
    useEffect(() => {
        axios.get('/api/me', { withCredentials: true })
            .then(res => {
                setUsername(res.data.username);
                setIsLoggedIn(true);
                localStorage.setItem('username', res.data.username);
            })
            .catch(() => {
                setIsLoggedIn(false);
                setUsername('');
                localStorage.removeItem('username');
            });
    }, []);

    const handleSearch = async () => {
        if (!query.trim()) return;
        try {
            const res = await axios.get('/search?q=' + query, { withCredentials: true });
            setResults(res.data.results);
            setSearched(true);
        } catch {
            setResults([]);
            setSearched(true);
        }
    };

    const handleLogout = async () => {
        localStorage.removeItem('username');
        await axios.get('/logout', { withCredentials: true });
        window.location.reload();
    };

    return (
        <div>
            <header>
                <nav className="navbar">
                    <div className="logo-text">S.I.M.E. drawings</div>
                    <div className="nav-right">
                        {isLoggedIn ? (
                            <>
                                <span style={{ fontWeight: 600, color: '#219653' }}>👤 {username}</span>
                                {username === 'SimeDrawingsAdmin' && (
                                    <a href="/admin" className="btn-login" style={{ background: '#1a1a1a' }}>⚙️ Admin</a>
                                )}
                                <button onClick={handleLogout} className="btn-login">Αποσύνδεση ➜</button>
                            </>
                        ) : (
                            <>
                                <a href="/login" className="btn-login">Σύνδεση ➜</a>
                                <a href="/register" className="btn-register">Εγγραφή 📝</a>
                            </>
                        )}
                        <a href="https://www.sime.gr" target="_blank" rel="noreferrer">
                            <img src="/static/img/logo.png" alt="S.I.M.E. Logo" className="right-img" />
                        </a>
                    </div>
                </nav>
            </header>

            <main className="grid-container">
                <svg className="tree-svg" viewBox="0 0 1000 800" preserveAspectRatio="none">
                    <path className="branch trunk" d="M500,800 L500,420 Q500,400 520,400 L640,400 Q666,400 666,380 L666,50" />
                    <path className="branch" d="M500,460 Q500,400 480,400 L350,400 Q333,400 333,420 L333,750" />
                    <path className="branch" d="M640,400 L950,400" />
                    <path className="branch" d="M350,400 L50,400" />
                    <path className="branch leaf" d="M666,200 Q690,200 700,180" />
                    <path className="branch leaf" d="M666,300 Q640,300 630,280" />
                    <path className="branch leaf" d="M333,550 Q310,550 290,570" />
                    <path className="branch leaf" d="M333,650 Q360,650 370,670" />
                </svg>

                <div className="grid-item item-1">
                    <div className="search-wrapper">
                        <h3>Αναζήτηση Σχεδίου</h3>
                        {isLoggedIn ? (
                            <>
                                <p>Πληκτρολογήστε το όνομα του αρχείου</p>
                                <div className="search-bar">
                                    <input
                                        type="text"
                                        value={query}
                                        onChange={e => setQuery(e.target.value)}
                                        onKeyPress={e => e.key === 'Enter' && handleSearch()}
                                        placeholder="Π.χ. ***.**.**.**"
                                    />
                                    <button className="search-btn" onClick={handleSearch}>
                                        Αναζήτηση 🔍
                                    </button>
                                </div>
                            </>
                        ) : (
                            <>
                                <p>Συνδεθείτε για να αναζητήσετε σχέδια</p>
                                <a href="/login" className="btn-login" style={{ display: 'inline-block', marginTop: 10 }}>
                                    Σύνδεση ➜
                                </a>
                            </>
                        )}
                    </div>
                </div>

                <div className="grid-item item-2">
                    {isLoggedIn ? (
                        <>
                            <h4>📂 Αποτελέσματα</h4>
                            {!searched && <p style={{ color: 'gray', fontSize: '0.9rem' }}>Κάντε αναζήτηση για να εμφανιστούν αρχεία.</p>}
                            {searched && results.length === 0 && <p style={{ color: 'gray' }}>Δεν βρέθηκαν αρχεία.</p>}
                            {results.map(d => (
                                <div key={d.id} style={{ padding: 12, border: '1px solid #eee', borderRadius: 8, marginBottom: 10, background: 'white' }}>
                                    <p style={{ fontWeight: 600, marginBottom: 8 }}>📄 {d.original_name}</p>
                                    <div style={{ display: 'flex', gap: 8 }}>
                                        <a href={'/sime/' + d.filename} target="_blank" rel="noreferrer"
                                            style={{ background: '#1a1a1a', color: 'white', padding: '6px 14px', borderRadius: 6, textDecoration: 'none', fontSize: '0.85rem' }}>
                                            👁️ Άνοιγμα
                                        </a>
                                        <a href={'/download/' + d.id}
                                            style={{ background: '#219653', color: 'white', padding: '6px 14px', borderRadius: 6, textDecoration: 'none', fontSize: '0.85rem' }}>
                                            ⬇️ Λήψη
                                        </a>
                                    </div>
                                </div>
                            ))}
                        </>
                    ) : (
                        <>
				<h4>📂 Αποτελέσματα</h4>
				        <div id="resultsList">
           			 <p style={{ color: 'gray', fontSize: '0.9rem' }}>Κάντε αναζήτηση για να εμφανιστούν αρχεία.</p>
        			</div>
                        </>
                    )}
                </div>

                <div className="grid-item item-3 main-site-card">
                    <h4>S.I.M.E. A.E.</h4>
                    <p>Επισκεφθείτε την επίσημη ιστοσελίδα μας για νέα και εταιρικά προφίλ.</p>
                    <a href="https://www.sime.gr/" target="_blank" rel="noreferrer" className="site-link-btn">
                        Μετάβαση στο sime.gr 🌐
                    </a>
                </div>

                <div className="grid-item item-4 contact-section">
                    <div className="contact-info">
                        <h4>Επικοινωνία</h4>
                        <p><strong>Τοποθεσία:</strong> 29ο χλμ. Π.Ε.Ο.Α.Θ. θέση Βάρη Νερό Μάνδρα Αττικής</p>
                        <p><strong>Τηλέφωνο:</strong> +30 210 555 1720</p>
                        <p><strong>Email:</strong> info@sime.gr</p>
                    </div>
			<form 
    id="simeContactForm" 
    className="contact-form"
    onSubmit={handleContact}>
    <input type="text" name="Ονοματεπώνυμο" placeholder="Ονοματεπώνυμο" className="form-input" required />
    <input type="email" name="Email" placeholder="Email" className="form-input" required />
    <textarea name="Μήνυμα" placeholder="Μήνυμα..." className="form-input" rows="2" required />
    <input type="hidden" name="_subject" value="SIME Drawings Portal" />
    <input type="hidden" name="_captcha" value="false" />
    <button type="submit" className="submit-btn">Αποστολή</button>
</form>
                </div>
            </main>
        </div>
    );
}

export default Home;
